import React from 'react'
import '../CSS/Navbar.css'
import { Link } from 'react-router-dom';
import { FaHeart, FaUser, FaCartPlus, FaTimes } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Hamburger from './Hamburger';

const NavBar = () => {

  const { cart } = useSelector(state => state)
  console.log(cart)

  const { reducer2 } = useSelector(state => state)
  console.log(reducer2)

  const [isSticky, setSticky] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.pageYOffset > 50) { // You can adjust the scroll position to trigger the sticky header
      setSticky(true);
      setShowCloseButton(true);
    } else {
      setSticky(false);
      setShowCloseButton(false);
    }
  };

  return (
    <div>
      <header className={isSticky ? "sticky" : " "}>
        <div class="top-row">
        <div className='menuIcon'>
          <Hamburger isOpen={isOpen} toggleMenu={toggleMenu} />
          </div>
          <div class="logo">
            <img src="/images/e-commerce-53871.png" alt="logo" />
          </div>

          <div className="nav-bar">
            <ul>
              <li ><Link to="/">Home</Link></li>
              <li><Link to="/product">Product </Link></li>
              <li><Link to="/categories">Categories </Link></li>
              <li><Link to="/about">About Us </Link></li>
              <li><Link to="/contact">Contact Us </Link></li>
            </ul>
          </div>
          <div className="icon">
            <ul>
              <li><Link to="/login"><FaUser /></Link></li>
              <li><Link to={`/wishlist`}><FaHeart />{reducer2.wishlist.length}</Link></li>              
              <li><Link to={`/cart`}><FaCartPlus />{cart.cart.length}</Link></li>
            </ul>
          </div>
        </div>

      </header>
      {isOpen && (
        <nav className="sidebar">
        {showCloseButton ? <FaTimes isOpen={isOpen} onClick={toggleMenu} className='close-btn' /> : ""}
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/product">Product</Link></li>
            <li><Link to="/categories">Categories</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/login"><FaUser /> Login</Link></li>
            <li><Link to={`/cart`}><FaCartPlus /> Cart ({cart.cart.length})</Link></li>
            <li><Link to={`/wishlist`}><FaHeart /> WishList ({reducer2.wishlist.length})</Link></li>
          </ul>
        </nav>
      )}
    </div>


  );
}

export default NavBar;